/**
 * Process items in batches to avoid overwhelming resources
 * @param {Array} items - The items to process
 * @param {number} batchSize - Number of items to process in parallel
 * @param {Function} processFn - Function to apply to each item
 * @returns {Promise<Array>} - Results from all processed items
 */
export const processInBatches = async (items, batchSize, processFn) => {
  const results = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const batchPromises = batch.map(processFn);

    const batchResults = await Promise.all(batchPromises);
    results.push(...batchResults);
  }
  return results;
};
/**
 * Converts an array of equivalent objects from camelCase to snake_case properties as preparation
 * for sending data to be processed.
 * @param {Array} equivalentsArray - Array of equivalent objects to convert
 * @returns {Array} - Array of converted equivalent objects
 */
export const reverseConvertEquivalents = (equivalentsArray) => {
  if (!Array.isArray(equivalentsArray)) return [];

  return equivalentsArray
    .map((equivalent) => {
      if (!equivalent) return null;

      const raw = {
        approval_date: equivalent.approvalDate,
        class_id: equivalent.classId,
        comments: equivalent.comments,
        expiration_date: equivalent.expirationDate,
        home_class_id: equivalent.homeClassId,
        home_class_title: equivalent.homeClassTitle,
        home_entity_id: equivalent.homeEntityId,
        id: equivalent.id,
      };

      const cleaned = Object.fromEntries(Object.entries(raw).filter(([_, v]) => v != null));

      return cleaned;
    })
    .filter((item) => item !== null);
};
